/**************************************************
 * Nombre:       Tarjeta_Contenido_Caps
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Contenido_Caps = ({item, index, click}) => {

    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1,py: 1}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 600}}>{item.tipo}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -0.5}}>
                <Typography sx={{fontSize: 14}}>{item.titulo}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Contenido_Caps